import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB9OjO97q-pggincaMGm1JL8zAuCLqM5tI',
    libraries: ['places']
  }
})
